import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectKeys } from '../projectKeys'
import {
  DocumentEngineTemplate,
  IDocumentEngineTemplate,
} from '@core/entities/document-engine'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const select = (response: IDocumentEngineTemplate[]) =>
  response.map(DocumentEngineTemplate.new)

export const useGetProjectDocumentEngineTemplates = (
  payload: RequestTypes['getProjectDocumentEngineTemplates'],
  options?: UseQueryOptions<
    IDocumentEngineTemplate[],
    RequestErrorType,
    DocumentEngineTemplate[]
  >,
) => {
  return useQuery({
    select,
    ...projectKeys
      .byId({ projectId: payload.projectIds[0] })
      ._ctx.projectDocumentEngineTemplates(payload),
    keepPreviousData: true,
    ...options,
  })
}
